<template>
<div>
  
  <div v-if="isDialer">
    <v-spacer></v-spacer>
    <v-btn
      text
      right
      v-on:click="$router.push('/dialer2')"
    >
      <v-icon>mdi-phone</v-icon>
    </v-btn>
    <v-btn
      text
      right
      v-on:click="$router.push('/voicemail')"
    >
      <v-icon>mdi-voicemail</v-icon>
    </v-btn>
  </div>

  <div v-if="isMessaging">
    <v-toolbar-title>Messaging</v-toolbar-title>
  </div>

  <div v-if="isAuthentication">
    <v-toolbar-title>Authentication</v-toolbar-title>
  </div>

  <div v-if="isSettings">
    <v-toolbar-title>Settings</v-toolbar-title>
  </div>

</div>
</template>

<script >
export default {
  data: function() {
    return {
      contact: {},
      dialog: false,
    }
  },
  props: {
  },
  computed: {
   isDialer: function() {
      if (this.$route.path == '/') {
        if (location.hostname != 'messages.rinble.com') {
          return true;
        }
      }
      if (this.$route.path == '/dialer2') {
        return true;
      }
      if (this.$route.path == '/voicemail') {
        return true;
      }
      if (this.$route.path == '/callhistory') {
        return true;
      }
      if (this.$route.path == '/directory') {
        return true;
      }
      return false;
    },
    isConferencing: function() {
      if (this.$route.path == '/conferences') {
        return true;
      }
      if (this.$route.path == '/conference') {
        return true;
      }
      return false;
    },
    isMessaging: function() {
      if (this.$route.path == '/') {
        if (location.hostname == 'messages.rinble.com') {
          return true;
        }
      }
      if (this.$route.path == '/chats') {
        return true;
      }
      if (this.$route.path == '/chat') {
        return true;
      }
      return false;
    },
    isAuthentication: function() {
      if (this.$route.path == '/authentication') {
        return true;
      }
      return false;
    },
    isSettings: function() {
      if (this.$route.path == '/prefs') {
        return true;
      }
      return false;
    },
  },
  methods: {

  },
  mounted() {
  },
  components: {

  },
}
</script>
